import { AbsenceReason } from 'Types/Absences/Absence'

// Colours match the .timeline-item-* classes in index.scss
export const ABSENCE_REASONS: Record<AbsenceReason, { label: string; color: string }> = {
  [AbsenceReason.VACATION]: { label: 'Vacation', color: '#799dec' },
  [AbsenceReason.SICK_LEAVE]: { label: 'Sick leave', color: '#a6df6d' },
  [AbsenceReason.PAID_LEAVE]: { label: 'Paid leave', color: '#f2c14e' },
  [AbsenceReason.REMOTE]: { label: 'Remote', color: '#ae89b8' },
  [AbsenceReason.UNIVERSITY]: { label: 'University', color: '#a373e6' },
  [AbsenceReason.BOOKING_OFFICE]: { label: 'Booking office', color: '#70e0d3' },
}

export const getAbsenceLabel = (reason: AbsenceReason | string | null | undefined) =>
  (reason && ABSENCE_REASONS[reason as AbsenceReason]?.label) || reason || ''
